import EntityTypes from 'parts/types/EntityTypes'
import PaymentTypes from 'parts/types/PaymentTypes'

export function useGetCurrencySign(price: EntityTypes.TariffPrice): string {
	return PaymentTypes.Currencies[price.currency].sign
}
